import { Injectable } from '@angular/core';
import { DossierSearchType, ofSearchType } from '@app/pcs/models';
import { DossierSearchGridColumnsService } from '@app/pcs/services/dossier-search-grid-columns.service';
import { throwError } from '@util/errors';
import { DataGridColumn } from 'ngrx-data-grid';
import * as R from 'ramda';

type ColumnsFor = (type: DossierSearchType) => DataGridColumn[];

@Injectable()
export class DossierSearchGridService {

  private readonly defaultColumns = (): DataGridColumn[] => [
    this.Columns.TimetablePeriodId(),
    this.Columns.TrafficLightsExtended(),
    this.Columns.TrafficLights(),
    this.Columns.TrainNumber(),
    this.Columns.PapId(),
    this.Columns.DossierName(),
    this.Columns.DossierStatus(),
    this.Columns.ProcessType(),
    this.Columns.DossierType(),
    this.Columns.TrainType(),
    this.Columns.DossierIdAndVersion(),
    this.Columns.LastChangeDate(),
    this.Columns.LastChangeAgency(),
    this.Columns.Observation(),
    this.Columns.Labels(),
    this.Columns.PathRequestLastDate()
  ];

  private readonly carryForwardColumns = (): DataGridColumn[] => [
    this.Columns.CarryForwarded(),
    ...this.defaultColumns()
  ];

  private getColumnsFor: ColumnsFor = (searchType) => R.cond([
    [
      ofSearchType([
        DossierSearchType.ADVANCED_SEARCH,
        DossierSearchType.QUICK_SEARCH,
        DossierSearchType.BULK_ACCEPTANCE_INDICATOR_EDIT,
        DossierSearchType.BULK_PERMANENT_ACCEPTANCE,
        DossierSearchType.BULK_DOSSIER_PROMOTION,
        DossierSearchType.BULK_RU_APPOINTMENT,
        DossierSearchType.BULK_RU_APPOINTMENT_PROCESSING,
        DossierSearchType.LABELS,
        DossierSearchType.FILTER,
        DossierSearchType.RECENT_ACTIVITY
      ]),
      this.defaultColumns
    ],
    [ofSearchType([DossierSearchType.CARRY_FORWARD]), this.carryForwardColumns],
    [R.T, throwError('Invalid DossierSearchType')]
  ])(searchType);

  getDossierSearchColumns(type: DossierSearchType): DataGridColumn[] {
    return this.getColumnsFor(type);
  }

  constructor(private Columns: DossierSearchGridColumnsService) {
  }
}
